window.TCB_LUNATRACK = window.TCB_LUNATRACK || {};
export function initClickReport(options = {}) {
    try {
        const clickReport = new window.$ClickReport.ReportForLuna(options);
        window.TCB_LUNATRACK['clickReport'] = clickReport;
    } catch (error) {
        console.log('luna-track initClickReport-error:', error);
    }
}
export function report(params, elementParamData) {
    try {
        const clickReport = window.TCB_LUNATRACK['clickReport'] || null;
        if (clickReport === null || typeof params !== 'object') {
            return;
        }
        console.log('______________clickreport3',clickReport)
        let elementParamLog = {};
        if (typeof elementParamData === 'object') {
            elementParamLog = clickReport.buildElementParamLog(elementParamData);
        }
        console.log('______________clickreport4',params)
        clickReport.report(clickReport.assignDeep({}, params, elementParamLog));

    } catch (error) {
        console.log('luna-track report-error:', error);
    }
}

export function initReportEvent(){
    //文字链埋点上报
    $(document)
        .on('click', '.clickreport', function(event) {
            console.log('______________clickreport')
            try {
                const clickLog = $(this).attr('data-clickLog') || ''
                const [modulePos = '',elementPos='',content = '',type= '',elementId='14',moduleId='text_link'] = clickLog.split('_')
                console.log('______________clickreport2',clickLog)
                report({
                    action:1003,
                    element_id:elementId,
                    module_id:moduleId,
                    module_pos:modulePos,
                    element_param:{
                        type,
                        content,
                        pos:elementPos
                    }
                })
            } catch (error) {
                console.log('luna-track initReportEvent-error:', error);
            }
            
        })
}


